import React, { Component } from "react";
import { Row } from "antd";
import { graphql } from "react-apollo";
import Spinner from "../../spinner/spinner";
import OtherBarriersList from "./otherBarriersList";
import BarriersChart from "./barriersChart";
import { getSubmittedBarriers } from "./queries/getSubmittedBarriers"
import "./barriers.css";

class BarriersPage extends Component {
  render() {
    if (this.props.data.loading) {
      return <Spinner />;
    }
    return (
      <div>
        <div className="dashboard-layout__placeholder"/>
        <div className="m-24">
          <Row>
            <BarriersChart {...this.props}/>
          </Row>
          <Row>
            <OtherBarriersList {...this.props}/>
          </Row>
        </div>
      </div>
    );
  }
}


export default graphql(getSubmittedBarriers, {
  options: ({ selectedChurch }) => ({ variables: { churchId: selectedChurch.id } })
})(BarriersPage);



// WEBPACK FOOTER //
// ./src/components/pages/barriers/barriers.js